import { ConfigurationContext } from 'components/provider/OrginazationContext';
import Modal from 'components/ui/Modal/modal';
import PrimaryButton from 'components/ui/PrimaryButton';
import SecondaryButton from 'components/ui/SecondaryButton';
import moment from 'moment';
import { useContext, useEffect, useRef, useState } from 'react';
import { BiCrosshair } from 'react-icons/bi';
import Select from 'react-select';
import { useReactToPrint } from 'react-to-print';
import { useCertificateSigunatureQuery } from 'redux/reducers/certification';
import { backendURL, nascsubdomain } from 'redux/reducers/settings';
import {
  ICertificate,
  IUpdateCertificateNumberInput,
  useGetLastCertificateNoQuery,
  useListTraineeQuery,
  useUpdateCertificateNumberMutation
} from 'redux/reducers/TraineeEvaluation';
import './certificate.css';
import TmsCertificate from './TmsCertificate';

interface PrintCertificateModalProps {
  templateModal: boolean;
  closeModal: () => void;
  selectedData: any;
}
export interface NepaliFiscalYearOption {
  value: string;
  label: string;
  from: string;
  to: string;
}

export const NepaliFiscalYearOptions: NepaliFiscalYearOption[] = [
  { value: '80/81', label: '२०८०/८१', from: '2023-07-17', to: '2024-07-15' },
  { value: '81/82', label: '२०८१/८२', from: '2024-07-16', to: '2025-07-16' },
  { value: '82/83', label: '२०८२/८३', from: '2025-07-17', to: '2026-07-16' },
  { value: '83/84', label: '२०८३/८४', from: '2026-07-17', to: '2027-07-16' },
  { value: '84/85', label: '२०८४/८५', from: '2027-07-17', to: '2028-07-15' },
];
const getCurrentFiscalYear = (): NepaliFiscalYearOption | null => {
  const today = new Date().toISOString().slice(0, 10); // Format: "YYYY-MM-DD"

  return (
    NepaliFiscalYearOptions.find(
      (fy) => today >= (fy.from || fy.from) && today <= (fy.to || fy.to)
    ) || null
  );
};

const PrintCertificateModal: React.FC<PrintCertificateModalProps> = ({
  templateModal,
  closeModal,
  selectedData
}) => {
  const { data: attendanceData, isLoading } = useListTraineeQuery(selectedData?.routine_master_id);
  const { data } = useCertificateSigunatureQuery();
  const { data: lastCertificateNo } = useGetLastCertificateNoQuery();
  const [updateCertificateNumber] = useUpdateCertificateNumberMutation();
  const templateNameAndRoleList =
    data &&
    data?.length > 0 &&
    data.map((item: any) => ({
      label: item.full_name,
      value: item.id,
      role: item.position,
      signature: item.signature || null
    }));
  const [selectedCordinator, setSelectedCordinator] = useState<any>(null);
  const [selectedDirector, setSelectedDirector] = useState<any>(null);
  const [selectedLeftSignatory, setSelectedLeftSignatory] = useState<any>(null);
  const [selectedSignatories, setSelectedSignatories] = useState<any[]>([]);
  const [selectedFiscalYear, setSelectedFiscalYear] = useState<any>(getCurrentFiscalYear());
  const MAX_SIGNATORIES = 3;
  const footerJustify =
    selectedSignatories.length === 1
      ? 'center'
      : selectedSignatories.length === 2
        ? 'space-between'
        : 'space-evenly';
  const [organisedFor, setOrganisedFor] = useState(
    'organised for the Officials of the Public Organization'
  );
  const [traineeList, setTraineeList] = useState<any[]>([]);
  const { appConfig } = useContext(ConfigurationContext);
  const isTms = appConfig?.domain_name === nascsubdomain;

  useEffect(() => {
    if (attendanceData?.data) {
      setTraineeList(attendanceData.data);
    }
  }, [attendanceData]);

  const heldFrom = moment(selectedData?.start_date).format('Do');
  const heldTo = moment(selectedData?.end_date).format('Do');
  const heldFromMonth = moment(selectedData?.start_date).format('MMMM');
  const heldToMonth = moment(selectedData?.end_date).format('MMMM');
  const heldYear = moment(selectedData?.end_date).format('YYYY');

  const printBillRef = useRef<HTMLDivElement>(null);

  const handlePrintBill = useReactToPrint({
    content: () => printBillRef.current,
    documentTitle: `Certificates-${selectedData?.training_details?.training_name || (isTms ? 'NASC' : 'NARTC')
      }`,
    pageStyle: isTms ? '@page { size: A4 landscape; margin: 0; }' : undefined,
    onAfterPrint: () => {
      if (traineeList.length === 0) return;
      const startNo = (lastCertificateNo?.data?.last_certificate_number || 0) + 1;

      const certificates: ICertificate[] =
        traineeList &&
        traineeList?.map((trainee: any, index: number) => ({
          trainee_id: trainee.id,
          certificate_number: (startNo + index).toString().padStart(6, '0') // change formatting if needed
        }));

      const payload: IUpdateCertificateNumberInput = {
        routine_id: selectedData?.routine_master_id,
        certificates
      };

      updateCertificateNumber(payload);
    }
  });

  const handleRemoveTrainee = (index: number) => {
    setTraineeList((prev) => prev.filter((_, i) => i !== index));
  };

  console.log(selectedData);


  return (
    <Modal
      title={'Print Certificate'}
      isModalOpen={templateModal}
      closeModal={closeModal}
      modalSize="modal-xl"
      renderFooter={() => (
        <div className="hstack gap-2 justify-content-end">
          <SecondaryButton title="Close" onClick={closeModal} />
          <PrimaryButton
            title={`Print (${traineeList.length})`}
            iconName="ri-printer-line"
            onClick={handlePrintBill}
            type="button"
          />
        </div>
      )}
    >
      {/* 1. Selection Controls */}
      {isTms ? (
        <div className="row mb-3 g-3">
          <div className="col-4">
            <label className="form-label">Left Signatory (Front)</label>
            <Select
              options={templateNameAndRoleList}
              onChange={(item: any) => setSelectedLeftSignatory({ ...item, detail: item })}
              value={selectedLeftSignatory}
            />
          </div>
          <div className="col-4">
            <label className="form-label">Right Signatory (Front)</label>
            <Select
              options={templateNameAndRoleList}
              onChange={(item: any) => setSelectedDirector({ ...item, detail: item })}
              value={selectedDirector}
            />
          </div>
          <div className="col-4">
            <label className="form-label">Course Coordinator (Back)</label>
            <Select
              options={templateNameAndRoleList}
              onChange={(item: any) => setSelectedCordinator({ ...item, detail: item })}
              value={selectedCordinator}
            />
          </div>
          <div className="col-12">
            <label className="form-label">Organised For</label>
            <input
              className="form-control"
              value={organisedFor}
              onChange={(e) => setOrganisedFor(e.target.value)}
            />
          </div>
        </div>
      ) : (
        <div className="row mb-3">
          <div className="col-6">
            <label className="form-label">Signatories (max {MAX_SIGNATORIES})</label>
            <Select
              isMulti
              options={templateNameAndRoleList || []}
              onChange={(items: any) =>
                setSelectedSignatories((items || []).map((item: any) => ({ ...item, detail: item })))
              }
              value={selectedSignatories}
              isOptionDisabled={() => selectedSignatories.length >= MAX_SIGNATORIES}
            />

          </div>
          <div className="col-6">
            <label className="form-label">Fiscal Year</label>
            <Select
              options={NepaliFiscalYearOptions || []}
              onChange={(items: any) =>
                setSelectedFiscalYear(items)
              }
              value={selectedFiscalYear}
            />

          </div>
        </div >
      )}

      {/* 2. Trainee Removal UI */}
      <div className="mb-4">
        <h6>Trainee List (Click red icon to remove from this print batch)</h6>
        <div className="d-flex flex-wrap gap-2 border p-3 bg-light rounded">
          {traineeList.length > 0 ? (
            traineeList.map((item: any, index: number) => (
              <div
                className="badge bg-white border text-dark d-flex align-items-center gap-2 p-2"
                key={index}
              >
                {`${item.first_name} ${item.last_name}`}
                <BiCrosshair
                  className="cursor-pointer text-danger"
                  size={18}
                  onClick={() => handleRemoveTrainee(index)}
                />
              </div>
            ))
          ) : (
            <p className="text-muted">No trainees found.</p>
          )}
        </div>
      </div>
      <div>Total Printed Certificate:{lastCertificateNo?.data?.last_certificate_number}</div>

      <hr />
      <h5>Preview</h5>

      <div ref={printBillRef} className="print-container">
        {isTms ? (
          <TmsCertificate
            selectedData={selectedData}
            traineeList={traineeList}
            organisedFor={organisedFor}
            leftSignatory={selectedLeftSignatory}
            rightSignatory={selectedDirector}
            courseCoordinator={selectedCordinator}
          />
        ) : (
          traineeList.map((item: any, index: number) => (
            <div className="certificate-page-break" key={index}>
              <div className="cert-wrapper">
                <div className="cert-container">
                  <div className="cert-watermark-new"></div>
                  <div className="cert-header">
                    <div className="cert-title-section">
                      <p className="red-text small">
                        {selectedData?.training_details?.training_code}-{selectedFiscalYear?.value}
                      </p>
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/2/23/Emblem_of_Nepal.svg"
                        alt="logo"
                        className="cert-logo"
                      />
                    </div>

                    <div className="cert-header-text">
                      <p className="red-text fs-4 fw-bold">Government of Nepal</p>
                      <p className="red-text fs-3 fw-bold">Ministry of Health and Food Safety</p>
                      <h2 className="red-text bold">
                        National Ayurveda Research and Training Center
                      </h2>
                      <p className="red-text fs-5 fw-bold">Kirtipur, Kathmandu, Nepal</p>
                    </div>
                    <div className="cert-flag-wrapper">
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/9/9b/Flag_of_Nepal.svg"
                        alt="flag"
                        className="cert-logo"
                      />
                    </div>
                  </div>

                  <div className="cert-title-section">
                    <div className="cert-title-text">
                      <h1 className="cert-main-title">CERTIFICATE</h1>
                      <p className="cert-subtitle">This is to certify that</p>
                    </div>

                    {item.image && (
                      <div className="cert-trainee-photo">
                        <img
                          src={backendURL + '/' + item.image}
                          alt="Trainee Photo"
                          className="trainee-photo-img"
                        />
                      </div>
                    )}
                  </div>
                  <div className="cert-body fs-2 ">
                    <div className="cert-name-line ">
                      <span className="fs-4 fw-bold">Mr/Miss/Ms</span>
                      <span className="dots-fill fs-3 fw-bold" style={{ wordSpacing: '4px' }}>
                        {[item?.first_name, item?.middle_name, item?.last_name]
                          .filter(Boolean)
                          .join('  ')}
                      </span>
                      <span className="fs-4 fw-bold">has successfully completed the</span>
                    </div>

                    <h3 className="cert-course">
                      "{selectedData?.training_details?.training_name || 'Training Program'}"
                    </h3>

                    <p className="cert-date fs-4 fw-bold ">
                      held on {heldFrom} {heldFromMonth} to {heldTo} {heldToMonth}, {heldYear}
                    </p>

                    <div className="cert-organizer fs-2 fw-bold ">
                      <p>Organized by : National Ayurveda Research and Training Center</p>
                      <p>Kirtipur, Kathmandu, Nepal</p>
                    </div>
                  </div>

                  <div className="cert-footer" style={{ justifyContent: footerJustify }}>
                    {selectedSignatories.map((signatory: any) => (
                      <div className="sig-block" key={signatory.value}>
                        <div className="sig-line" style={{ position: 'relative' }}>
                          {signatory?.detail?.signature ? (
                            <img
                              src={backendURL + '/' + signatory?.detail?.signature}
                              alt="signature"
                              style={{
                                width: '100px',
                                height: '40px',
                                position: 'absolute',
                                bottom: 0
                              }}
                            />
                          ) : (
                            ''
                          )}
                          ..........................................
                        </div>
                        <p className="sig-name">{signatory?.label || ''}</p>
                        <p>{signatory?.detail?.role || ''}</p>
                        <p>NARTC</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </Modal >
  );
};

export default PrintCertificateModal;
